import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { Modal } from "react-bootstrap";

import {
  cancelPendingTransaction,
  getTransactions,
} from "actions/transactionActions";

import Button from "components/Button";
import Alert from "components/Alert";

import { createLoadingSelector, createErrorSelector } from "store/selectors";
import { transactionConstants } from "actions/types";
import { getIraAccountIdSelector } from "store/selectors/user";
import type { RootState } from "types/state";

const actions = [transactionConstants.CANCEL_TRANSACTION];

const isCancelling = createLoadingSelector(actions);

const errorSelector = createErrorSelector(actions);

interface OwnProps {
  onClose: () => void;
  transactionId?: string;
}

const mapStateToProps = (state: RootState) => {
  return {
    isCancelling: isCancelling(state),
    error: errorSelector(state),
    // narrow away `null | undefined` from the shallow-typed selector
    // (getIraAccountIdSelector returns string | null | undefined)
    accountId: getIraAccountIdSelector(state) as string,
  };
};

const mapDispatchToProps = {
  cancelPendingTransaction,
  getTransactions,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type Props = WithApolloClient<OwnProps & ConnectedProps<typeof connector>>;

class ConfirmAchCancellationModal extends React.PureComponent<Props> {
  _onCancel = async () => {
    try {
      await this.props.cancelPendingTransaction(
        this.props.client as ApolloClient<object>,
        this.props.accountId,
        this.props.transactionId as string
      );
      this.props.onClose();
      // fire-and-forget refetch — REQUEST/SUCCESS land in the reducer
      void this.props.getTransactions(
        this.props.client as ApolloClient<object>,
        this.props.accountId
      );
    } catch {
      // error should get caught by reducer logic
      return;
    }
  };

  render() {
    return (
      <Modal
        centered
        scrollable
        show={true}
        onHide={this.props.onClose}
        className="contribution-modal"
      >
        <Modal.Header className="header" closeButton={false}>
          <Modal.Title className="title">
            Confirm transfer cancellation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <p style={{ margin: 20, color: "#0A2540" }}>
            Once confirmed, we will submit a request to cancel the transfer.
            Cancellation can take 3-5 business days to complete.
          </p>
          {this.props.error && <Alert type="error" msg={this.props.error} />}
        </Modal.Body>
        <Modal.Footer>
          <Button
            btnLabel="Close"
            color="cancel"
            name="cancel"
            onClick={this.props.onClose}
          />
          <span className="remove-bank">
            <Button
              className="cancel-transaction"
              btnLabel="Cancel Transaction"
              color="red"
              name="submit"
              withArrow
              loading={this.props.isCancelling}
              onClick={() => {
                void this._onCancel();
              }}
            />
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connector(withApollo<Props>(ConfirmAchCancellationModal));
